import { FC, memo } from 'react'
import { useTranslation } from 'react-i18next'

import { Slide, Slider } from '@/components/molecules/Slider'

import { IPromoPool } from '@/interfaces'

import { usePromoPool } from '../../hooks/usePromoPools'
import { ConversationWidget } from './ConversationWidget'

const TrendingConversationsWidgetComponent: FC<{ pool: IPromoPool }> = ({
  pool,
}) => {
  const {
    data: conversations,
    isLoading,
    fetchNextPage,
    hasNextPage,
  } = usePromoPool(pool)
  const { t } = useTranslation('common')

  if (conversations.length < 5 || isLoading) {
    return null
  }

  return (
    <section className="px-3 py-3">
      <strong className="block pb-4 text-lg">
        {t('promoWidgets.trendingConversations.title')}
      </strong>
      {
        <Slider
          onCloseToTheEnd={() => {
            if (!isLoading && hasNextPage) {
              fetchNextPage()
            }
          }}
        >
          {conversations.map((conversation) => (
            <Slide key={conversation.id}>
              <ConversationWidget
                {...{
                  imageUrl: conversation.imageUrl,
                  title: conversation.metadata.title,
                  url: conversation.url,
                  userId: conversation.metadata.userId,
                  username: conversation.metadata.username,
                }}
              />
            </Slide>
          ))}
        </Slider>
      }
    </section>
  )
}

export const TrendingConversationsWidget = memo(
  TrendingConversationsWidgetComponent
)
